import {Fitrite365QuoteMeasurementRequest} from "./Fitrite365QuoteMeasurementRequest";

export class BespokeQuoteCreationRequest{
  templateId: string;
  customerId: number;
  customerName: string;
  customerEmail: string;
  customerPhone: string;
  gateCount: number;
  stepsCount: number;
  deckColour: string;
  balustradeColour: string;
  hatchCount: number;
  plot: string;
  comments?: string;
  deckSkirted: boolean;
  caravanSkirted: boolean;
  caravanHeight: number;
  numberOfGates: number;
  numberOfHatches: number;
  numberOfStepSets: number;

  measurements: Fitrite365QuoteMeasurementRequest[];
}
